<script>
  import { onMount, afterUpdate } from "svelte";
  import { createEventDispatcher } from "svelte";

  // Define the component's properties
  export let value = 2; // Default value
  export let min = 1;
  export let max = 3;

  const dispatch = createEventDispatcher();

  const labels = [
    { label: "barely", value: 1, align: "flex-start" },
    { label: "average", value: 2, align: "center" },
    { label: "plenty", value: 3, align: "flex-end" },
  ];

  let position = ((value - min) / (max - min)) * 100;

  function updatePosition() {
    position = ((value - min) / (max - min)) * 100;
  }

  let isDragging = false;
  let slider;
  let thumb;

  function handleMouseDown(event) {
    isDragging = true;
    slider = event.currentTarget;

    function handleMouseMove(event) {
      if (isDragging) {
        const rect = slider.getBoundingClientRect();
        const newPosition = ((event.clientX - rect.left) / rect.width) * 100;
        position = Math.min(100, Math.max(0, newPosition));
        thumb.style.left = `${Math.min(
          Math.max(position, 100 / ((max - min + 1) * 2)),
          100 - 100 / ((max - min + 1) * 2)
        )}%`;
        updateValue();
      }
    }

    function handleMouseUp() {
      isDragging = false;
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    }

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);
  }

  function handleClick(event) {
    event.stopPropagation();
    const rect = slider.getBoundingClientRect();
    const newPosition = ((event.clientX - rect.left) / rect.width) * 100;
    position = Math.min(100, Math.max(0, newPosition));
    updateValue();
  }

  function updateValue() {
    value = Math.round((position / 100) * (max - min) + min);
    dispatch("change", { value });
    if (!isDragging) {
      thumb.style.left = `${(value - 1) * (100 / (max - min + 1)) + 50 / (max - min + 1)}%`;
    }
  }

  onMount(updatePosition);
  afterUpdate(updatePosition);
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div
  class="slider cursor-oversized"
  on:mousedown={handleMouseDown}
  on:click={handleClick}
  bind:this={slider}
  style="justify-content: {labels[value - 1].align};"
>
  <div class="labels">
    {#each labels as label}
      <div class="label" class:active={label.value === value}>
        {label.label}
      </div>
    {/each}
  </div>
  <div
    class="thumb"
    bind:this={thumb}
    style="left: {(value - 1) * (100 / (max - min + 1)) +
      50 / (max - min + 1)}%; width: calc(100% / {max - min + 1})"
  />
</div>

<style>
  .slider {
    width: 200px;
    height: 24px;
    background-color: var(--rekki-neutral-01);
    position: relative;
    border-radius: 30px;
    /* padding: 2px; */
    display: flex;
    justify-content: flex-start;
    /* box-sizing: border-box; */
    border: 2px solid var(--rekki-neutral-01);
  }

  .labels {
    display: flex;
    justify-content: space-around;
    font-family: "REKKI-OCD";
    text-transform: uppercase;
    position: absolute;
    left: 0;
    top: 0;
    font-size: 12px;
    width: 100%;
    height: 100%;
    align-items: center;
    pointer-events: none;
    user-select: none;
    z-index: 2;
  }

  .label {
    opacity: 0.5;
  }

  .label.active {
    opacity: 1;
  }

  .thumb {
    height: 20px;
    background-color: #fff;
    border-radius: 30px;
    user-select: none;
    position: absolute;
    left: 0;
    top: 0;
    transition: left 0.2s ease-out;
    z-index: 1;
    transform: translateX(-50%);
  }
</style>
